module.exports = __webpack_public_path__ + "static/img/964a4038-9fc4-4210-8b39-faddc8322c1d.4027eef7.jpg";